import clsx from "clsx";
import styles from "./styles.module.css";

function Loader() {
  return (
    <div className={clsx(styles.loaderContainer)}>
      <div className={clsx(styles.loader)}>&nbsp;</div>
    </div>
  )
}
export default Loader;